"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _react.default.createElement("svg", {
  width: "18",
  height: "17",
  viewBox: "0 0 18 17"
}, _react.default.createElement("path", {
  d: "M5.64 5.32A3.35 3.35 0 018.98 2a3.35 3.35 0 013.34 3.34c.04.96-.32 2.05-.96 2.9-.64.86-1.49 1.4-2.38 1.4-.83 0-1.66-.53-2.3-1.4a5.12 5.12 0 01-1.04-2.92zM8.98 1a4.35 4.35 0 00-4.34 4.32c0 1.2.48 2.52 1.23 3.52s1.84 1.8 3.11 1.8c1.3 0 2.42-.79 3.18-1.8.76-1 1.21-2.32 1.16-3.53C13.32 2.94 11.36 1 8.98 1zM4.65 9.95a.5.5 0 00-.45-.9A5.75 5.75 0 001 14.1c0 .18.06.52.32.8l.12.1.15.1.44.25c.37.2.88.45 1.54.69 1.3.48 3.15.95 5.41.95 2.72.01 4.62-.46 5.86-.96a7.24 7.24 0 001.72-.99 1.39 1.39 0 00.16-.18c.16-.18.28-.45.28-.74 0-2.14-1.2-4.08-3.2-5.05a.5.5 0 00-.44.9 4.59 4.59 0 012.63 4.2.2.2 0 01-.02.03.5.5 0 00-.07.09l-.01.01-.25.2c-.24.16-.63.38-1.18.6-1.1.45-2.87.9-5.48.9-2.12-.01-3.85-.45-5.07-.9a11.07 11.07 0 01-1.88-.91.23.23 0 01-.03-.08v-.01a4.75 4.75 0 012.65-4.15z"
}));

exports.default = _default;